/*
 * @Author: your name
 * @Date: 2021-07-12 18:08:38
 * @LastEditTime: 2021-07-13 15:06:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\utils\index.js
 */

/**
 * 已知角度和斜边，求直角边
 * angle 角度
 * long 斜边长
 */
export const hypotenuse = (long, angle) => {
  // 获得弧度
  var radian = ((2 * Math.PI) / 360) * angle;
  return {
    a: Math.sin(radian) * long, // 对边
    b: Math.cos(radian) * long // 邻边
  };
};
export const _color = text => {
  if (parseInt(text) > 0) {
    return "#f10";
  }
  switch (text) {
    case "一级":
    case "重大风险":
    case "离线":
    case "否":
    case "高风险":
    case "增":
      return "#f10";
    case "二级":
    case "较大风险":
      return "#ff9840";
    case "三级":
    case "一般风险":
      return "#ece93f";
    case "四级":
    case "低风险":
    case "消":
      return "#3ad0eb";
    default:
      return "#fff";
  }
  // if (arrRed.includes(text)) {
  //   return 'red';
  // } else {
  //   return '#fff';
  // }
};

export const _count = (item, r) => {
  const lng = item.length;
  item.forEach((item, index) => {
    const data = _getPositions(lng, index, r);
    if (!item.id) {
      item.id = index;
    }
    item.left = data.left;
    item.top = data.top;
  });
  return item;
};

export const _getPositions = (length, index, r) => {
  const num = r;
  const itemAngle = 360 / length;
  const half = itemAngle / 2;
  let angle = index * itemAngle;
  let datas;
  if (length > 5) {
    angle += half;
  }
  if (angle === 0 || angle === 360) {
    return {
      left: 0,
      top: -num
    };
  }
  if (angle < 90) {
    datas = hypotenuse(num, angle);
    return {
      left: datas.a,
      top: -datas.b
    };
  } else if (angle === 90) {
    return {
      left: num,
      top: 0
    };
  } else if (angle < 180) {
    angle = 180 - angle;
    datas = hypotenuse(num, angle);
    return {
      left: datas.a,
      top: datas.b
    };
  } else if (angle === 180) {
    return {
      left: 0,
      top: num
    };
  } else if (angle < 270) {
    angle = 270 - angle;
    datas = hypotenuse(num, angle);
    return {
      left: -datas.b,
      top: datas.a
    };
  } else if (angle === 270) {
    return {
      left: -num,
      top: 0
    };
  } else if (angle < 360) {
    angle = 360 - angle;
    datas = hypotenuse(num, angle);
    return {
      left: -datas.a,
      top: -datas.b
    };
  }
};

/**
 * 将日期转化为年月日时分秒
 */
export const formatDateHMS = value => {
  if (!value) {
    return "- -";
  }
  const date = new Date(value);
  const y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
};

export const formatDateHMSSJC = value => {
  if (!value) {
    return "- -";
  }
  const date = new Date(Number(value));
  const y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
};
